import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * Assim como o Ensino, o Plano Curricular atende o ano letivo e o histórico (ANO = 0). As telas
 * são as mesmas; `meta.ensinoHistorico` é o que diz de qual dos dois se trata.
 */
export default [
  {
    description: 'Planos Curriculares',
    path: '/academico/parametros/planocurricular',
    name: 'planocurricular',
    component: () => import('@/views/academico/parametros/planocurricular/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.PLANOSCURRICULARES_MENUNOVO_300900201],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Plano Curricular',
    path: '/academico/parametros/planocurricular/cadastro/:id?',
    parent: 'planocurricular',
    name: 'planocurricular_create',
    component: () => import('@/views/academico/parametros/planocurricular/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.PLANOSCURRICULARES_MENUNOVO_300900201],
    },
  },
  {
    description: 'Disciplinas do Plano Curricular',
    path: '/academico/parametros/planocurricular/:codigoGrade/conteudos',
    parent: 'planocurricular',
    name: 'gradeconteudo',
    component: () => import('@/views/academico/parametros/gradeconteudo/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.PLANOSCURRICULARES_MENUNOVO_300900201],
    },
  },
  {
    description: 'Planos Curriculares do Histórico',
    path: '/academico/parametros/planocurricularhistorico',
    name: 'planocurricularhistorico',
    component: () => import('@/views/academico/parametros/planocurricular/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.PLANOSCURRICULARESDOHISTORICO_MENUNOVO_300700901],
      ensinoHistorico: true,
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Plano Curricular do Histórico',
    path: '/academico/parametros/planocurricularhistorico/cadastro/:id?',
    parent: 'planocurricularhistorico',
    name: 'planocurricularhistorico_create',
    component: () => import('@/views/academico/parametros/planocurricular/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.PLANOSCURRICULARESDOHISTORICO_MENUNOVO_300700901],
      ensinoHistorico: true,
    },
  },
  {
    description: 'Disciplinas do Plano Curricular do Histórico',
    path: '/academico/parametros/planocurricularhistorico/:codigoGrade/conteudos',
    parent: 'planocurricularhistorico',
    name: 'gradeconteudohistorico',
    component: () => import('@/views/academico/parametros/gradeconteudo/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.PLANOSCURRICULARESDOHISTORICO_MENUNOVO_300700901],
      ensinoHistorico: true,
    },
  },
];
